import backgroundVideo from "../../assets/images/backgroundProducts.mp4";
import "./style.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { img9, img10, img11, img12 } from "../../assets/images/livestock"

const livestockDetails = {
    name: "Livestock Fattening ERP",
    description: "The Livestock Fattening ERP streamlines the livestock fattening process, from tag ID generation and mandi expense tracking to animal routing (quarantine, lairage, barn, hospital, or mortality) based on health and weight. It manages procurement, inventory (medicines, vaccines, feed), custom feed mixtures, weight monitoring, and vaccination schedules. Animals are eventually sent for slaughter, with products like meat and offal sold to customers. This system ensures efficient tracking, cost management, and profitability for livestock operations.",
    images: [img9, img10, img11, img12]
}

const EnterpriseResourcePlanning = () => {
    const settings = {
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 1,
        speed: 500
      };
    return (
        <div className="w-full relative h-full">
      {/* Background Section */}
      <section id="heading" className="relative flex">
        {/* Background Video */}
        <video
          className="absolute inset-0 w-full h-full object-cover"
          src={backgroundVideo}
          autoPlay
          loop
          muted
          style={{ opacity: "0.25" }}
        />

        {/* Heading Content */}
        <div className="relative max-w-7xl mx-auto flex flex-col items-center justify-center h-screen z-10">
          <h1 className="text-4xl lg:text-5xl font-bold text-center text-white">
            <span className="gradient-headings">{livestockDetails.name}</span>
          </h1>
          <p className="text-xl lg:text-2xl text-white mt-6 mx-auto max-w-4xl px-4 text-justify md:text-center">
            The <span className="font-bold">Real Estate Management ERP</span> is a cloud-based SaaS platform
            designed to streamline real estate operations with advanced multi-tenancy, branch-wise configurations,
            and role-based access control.
          </p>
        </div>
      </section>

      {/* Description Section */}
      <section className="pb-10 px-4 md:px-8 bg-gradient-to-r from-slate-950/80 via-slate-950/90 to-slate-950/100">
        <div className="container mx-auto flex flex-col-reverse md:flex-col   gap-10 xl:gap-16 items-center">
          <div className="text-base lg:text-xl text-white px-4 xl:mt-24">
            <p className="text-justify">{livestockDetails.description}</p>
          </div>
          <div className="w-full px-4 slider-container">
            <Slider {...settings}>
              {livestockDetails.images.map((image, index) => (
                <div key={index} className="">
                  <img
                    src={image}
                    alt="product images"
                    className="w-full h-auto rounded-lg shadow-lg object-cover"
                  />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    </div>
    )
}

export default EnterpriseResourcePlanning